export enum SponsorsImageType {
  LOGO = 'logo',
  IMAGE = 'image'
}
